export default __webpack_public_path__ + "static/distributors-725c6faa2edecf048e3154a76cc6680f.png";